import type { PracticeVoice } from "@/types";

export const DEFAULT_PRACTICE_VOICE: PracticeVoice = "calm";

export const PRACTICE_VOICES: readonly PracticeVoice[] = [
  "calm",
  "warm",
  "bright",
  "grounded",
] as const;

export function voiceClipKey(messageId: string, voice: PracticeVoice): string {
  return `${messageId}:voice:${voice}`;
}
